import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

const types = {
  SET_TOKEN: 'SET_TOKEN', // 用户信息
  SET_STORY: 'SET_STORY', // 用户信息
  SET_ROLE: 'SET_ROLE'// 用户角色
}
let debug = false
const state = { // 需要维护的状态
  isAuthenticated: false, // 是否认证
  token: '',
  urlquery: '',
  showZhilingPanelFlag: false,
  showGraphPanelFlag: false,
  dialogShowCostomContactFlag: false, // 联系客服
  dialogShowRechargeFlag: false, // 充值
  dialogShowNewerGiftFlag: false, // 大礼包
  dialogShowNewerGiftXiboFlag: false, // 喜播 大礼包
  showDialogCdpFlag: false, // 是否认证
  showDialogRecommendFlag: false, // 是否认证
  showDialogDpFlag: false, // 是否认证
  showDialogDpQuestionFlag: false, // 是否认证
  showChangpianDialogFlag: false, //
  showBreakdownDialogFlag: false, //
  showBreakdownDetailDialogFlag: false,
  showBreakdownDetailDialogFlagV2: false,
  showBreakdownDetailDialogFlagHe: false,
  showLoginDialogFlag: false, //
  showGenbyoutlineFlag: false,
  dialogShowPaySuccessFlag: false,
  showVideoFlag: false,
  hideFlagML: false,
  hideFlagZW: false,
  hideFlagMLZW: false,
  showMenuFlag: false,
  successFlag: false,
  user: {id: ''}, //
  story: {id: ''}, //
  activeQuestion: {}, //
  activeTemplate: {id: '-1'},
  storyContents: [], //
  role: [],
  storyTiaojian: [],
  notifies: [],
  enums: {},
  uploadFile: {},
  activeMenuItem: '1',
  currentNotifyId: '0',
  cozeBot: { },
}

const mutations = {
  setIsAuthenticated(state, isAuthenticated) {
    if (isAuthenticated) { state.isAuthenticated = isAuthenticated } else { state.isAuthenticated = false }
  },
  setToken(state, token) {
    if (token) { state.token = token } else { state.token = '' }
  },
  setCurrentNotifyId(state, currentNotifyId) {
    if (currentNotifyId) { state.currentNotifyId = currentNotifyId } else { state.currentNotifyId = '0' }
  },
  setUser(state, user) {
    if (user) { state.user = user } else { state.user = {} }
  },
  setRole(state, role) {
    state.role = role
  },
  setCozeBot(state, cozeBot){
    state.cozeBot = cozeBot
  },
  setShowZhilingPanelFlag(state, showZhilingPanelFlag) {
    state.showZhilingPanelFlag = showZhilingPanelFlag
  },
  setShowGraphPanelFlag(state, showGraphPanelFlag) {
    state.showGraphPanelFlag = showGraphPanelFlag
  },
  setStoryTiaojian(state, storyTiaojian) {
    state.storyTiaojian = storyTiaojian
  },
  setNotify(state, notifies) {
    state.notifies = notifies
  },
  setActiveMenuItem(state, activeMenuItem) {
    state.activeMenuItem = activeMenuItem
  },
  setActiveQuestion(state, activeQuestion) {
    state.activeQuestion = activeQuestion
  },
  setActiveTemplate(state, activeTemplate) {
    state.activeTemplate = activeTemplate
  },
  setStory(state, story) {
    if (story) { state.story = story } else { state.story = { id: ''} }
  },
  setStoryContents(state, storyContents) {
    state.storyContents = Array.from(storyContents);
  },
  setShowDialogRecommendFlag(state, showDialogRecommendFlag) {
    state.showDialogRecommendFlag = showDialogRecommendFlag;
  },
  setShowDialogCdpFlag(state, showDialogCdpFlag) {
    state.showDialogCdpFlag = showDialogCdpFlag;
  },
  setShowDialogDpFlag(state, showDialogDpFlag) {
    state.showDialogDpFlag = showDialogDpFlag;
  },
  setShowGenbyoutlineFlag(state, showGenbyoutlineFlag) {
    state.showGenbyoutlineFlag = showGenbyoutlineFlag;
  },
  setShowDialogDpQuestionFlag(state, showDialogDpQuestionFlag) {
    state.showDialogDpQuestionFlag = showDialogDpQuestionFlag;
  },
  setShowChangpianDialogFlag(state, showChangpianDialogFlag) {
    state.showChangpianDialogFlag = showChangpianDialogFlag;
  },
  setShowBreakdownDialogFlag(state, showBreakdownDialogFlag) {
    state.showBreakdownDialogFlag = showBreakdownDialogFlag;
  },
  setShowBreakdownDetailDialogFlag(state, showBreakdownDetailDialogFlag) {
    state.showBreakdownDetailDialogFlag = showBreakdownDetailDialogFlag;
  },
  setShowBreakdownDetailDialogFlagV2(state, showBreakdownDetailDialogFlagV2) {
    state.showBreakdownDetailDialogFlagV2 = showBreakdownDetailDialogFlagV2;
  },
  setShowBreakdownDetailDialogFlagHe(state, showBreakdownDetailDialogFlagHe) {
    state.showBreakdownDetailDialogFlagHe = showBreakdownDetailDialogFlagHe;
  },
  setDialogShowCostomContactFlag(state, dialogShowCostomContactFlag) {
    state.dialogShowCostomContactFlag = dialogShowCostomContactFlag;
  },
  setDialogShowRechargeFlag(state, dialogShowRechargeFlag) {
    state.dialogShowRechargeFlag = dialogShowRechargeFlag;
  },
  setDialogShowNewerGiftFlag(state, dialogShowNewerGiftFlag) {
    state.dialogShowNewerGiftFlag = dialogShowNewerGiftFlag;
  },
  setDialogShowNewerGiftXiboFlag(state, dialogShowNewerGiftXiboFlag) {
    state.dialogShowNewerGiftXiboFlag = dialogShowNewerGiftXiboFlag;
  },
  setDialogShowPaySuccessFlag(state, dialogShowPaySuccessFlag) {
    state.dialogShowPaySuccessFlag = dialogShowPaySuccessFlag;
  },
  setShowLoginDialogFlag(state, showLoginDialogFlag) {
    state.showLoginDialogFlag = showLoginDialogFlag;
  },
  setShowMenuFlag(state, showMenuFlag) {
    state.showMenuFlag = showMenuFlag;
  },
  setShowVideoFlag(state, showVideoFlag) {
    state.showVideoFlag = showVideoFlag;
  },
  setSuccessFlag(state, successFlag) {
    state.successFlag = successFlag;
  },
  setUrlquery(state, urlquery) {
    state.urlquery = urlquery
  },
  setEnums(state, enums) {
    state.enums = enums
  },
  setUploadFile(state, uploadFile) {
    state.uploadFile = uploadFile
  },
  clearCurrentState(state, data) {

    state.isAuthenticated = false
    state.activeMenuItem = '1'
    state.token = ''
    state.urlquery = ''
    state.story = {id: ''}
    state.role = []
    state.user = {id: ''}
    state.story = {id: ''}
    state.activeTemplate = {id: '-1'}
    state.activeQuestion = {}
    state.cozeBot = {}

    console.log('clear...');

    localStorage.removeItem('lyToken')
    localStorage.removeItem('lyAccount')
    localStorage.removeItem('lyActions')
    localStorage.removeItem('activeId')
    localStorage.removeItem('currentId')
    localStorage.removeItem('currentPath')
    localStorage.removeItem('processInstanceId')
    localStorage.removeItem('queueName')
    localStorage.removeItem('urlquery')
    localStorage.removeItem('showInviteFlagAb')

  }
}

const actions = {
  // 设置角色
  setRole: ({ commit }, role) => {
    if(debug) console.log(commit, role);
    commit('setRole', role)
  },
  // 设置认证
  setIsAuthenticated: ({ commit }, isAuthenticated) => {
    if(debug) console.log(commit, isAuthenticated);
    commit('setIsAuthenticated', isAuthenticated)
  },
  // 设置用户
  setUser: ({ commit }, user) => {
    if(debug) console.log(commit, user);
    commit('setUser', user)
  },
  // 设置故事
  setStory: ({ commit }, story) => {
    if(debug) console.log(commit, story);
    commit('setStory', story)
  },
  // 设置故事
  setStoryContents: ({ commit }, storyContents) => {
    if(debug) console.log(commit, storyContents);
    commit('setStoryContents', storyContents)
  },
  // 设置 Token
  setToken: ({ commit }, token) => {
    if(debug) console.log(commit, token);
    commit('setToken', token)
  },
  // 设置 setShowDialogFlag
  setShowDialogFlag: ({ commit }, showDialogFlag) => {
    if(debug) console.log(commit, showDialogFlag);
    commit("setShowDialogFlag", showDialogFlag)
  },
  // 设置 dialogShowCostomContactFlag
  setDialogShowCostomContactFlag: ({ commit }, dialogShowCostomContactFlag) => {
    if(debug) console.log(commit, dialogShowCostomContactFlag);
    commit("setDialogShowCostomContactFlag", dialogShowCostomContactFlag)
  },
  setDialogShowRechargeFlag: ({ commit }, dialogShowRechargeFlag) => {
    if(debug) console.log(commit, dialogShowRechargeFlag);
    commit("setDialogShowRechargeFlag", dialogShowRechargeFlag)
  },
  setShowVideoFlag: ({ commit }, showVideoFlag) => {
    if(debug) console.log(commit, showVideoFlag);
    commit("setShowVideoFlag", showVideoFlag)
  },
  setUrlquery: ({ commit }, urlquery) => {
    if(debug) console.log(commit, urlquery);
    commit("setUrlquery", urlquery)
  },
  setActiveMenuItem: ({ commit }, activeMenuItem) => {
    if(debug) console.log(commit, activeMenuItem);
    commit("setActiveMenuItem", activeMenuItem)
  }
}

export default new Vuex.Store({
  plugins: [createLogger()],
  state,
  // getters,
  mutations,
  actions
})
